export default {"src":"/_next/static/media/emirates.162fafce.svg","height":73,"width":89,"blurWidth":0,"blurHeight":0};